<p-tabs value="nyc-sync" [value]="initialSegment()">
  <p-tablist>
    <p-tab value="nyc-sync" [routerLink]="['nyc-sync']">NYC Sync</p-tab>
    <p-tab value="users" [routerLink]="['users']">Users</p-tab>
    <p-tab value="emails" [routerLink]="['emails']">Emails</p-tab>
    <p-tab value="apartments" [routerLink]="['apartments']">Apartments</p-tab>
    <p-tab value="failed-applications" [routerLink]="['failed-applications']">Failed Applications</p-tab>
    <p-tab value="delayed-applications" [routerLink]="['delayed-applications']">Delayed Applications</p-tab>
    <p-tab value="cancels" [routerLink]="['cancels']">Cancels</p-tab>
    <p-tab value="exports" [routerLink]="['exports']">Exports</p-tab>
    @if (manualCheckEnabled) {
      <p-tab value="notification-check" [routerLink]="['notification-check']">Notification check</p-tab>
    }
<p-tab value="command-for-users" [routerLink]="['command-for-users']">Command for users</p-tab>
    <p-tab value="config" [routerLink]="['config']">Config</p-tab>
    <p-tab value="marketing-notification" [routerLink]="['marketing-notification']">Marketing notification</p-tab>
    <p-tab value="feedback" [routerLink]="['feedback']">Feedback</p-tab>
    <p-tab value="ratings" [routerLink]="['ratings']">Ratings</p-tab>
    <p-tab value="market-research-questions" [routerLink]="['market-research-questions']">Marketing questions</p-tab>
  </p-tablist>
</p-tabs>
<router-outlet/>
